<template>
	<div class="subheader-fixed aside-enabled aside-fixed aside-minimize-hoverable page-loading">
		<div class="d-flex flex-row flex-column-fluid page" :style="progressLoader ? 'pointer-events: none;opacity:0.3' : 'pointer-events: auto'">
	    <sidebar></sidebar>
		<div class="d-flex flex-column flex-row-fluid wrapper" :class="{'mb-20' :showAppBanner}" id="kt_wrapper">
			<topbar  v-if="['admin','owner','staff'].includes(this.$store.state.role)"></topbar>
				<div class="alert alert-warning text-center"
					v-if="showEmailLimitAlert"
					style="background: #FFF6E5; color: #8A6D3B; padding: 15px; border-radius: 6px; margin-bottom: 0; z-index: 1050;">
					<i class="icon-exclamation-sign"></i>
					<strong>You've reached your daily email limit ({{ emailCount }}/{{ emailLimit }} emails).</strong>
					You can resume sending emails tomorrow once your limit resets.
				</div>
			<div id="kt_content" class="content d-flex flex-column flex-column-fluid">
				 <notifications width="400" group="notify" position="top right"/>
				 <loader v-if="progressLoader"></loader>
				 <template v-if="['admin','owner','staff'].includes(this.$store.state.role)">
					<router-view :stripe-status= "stripeStatus"/>
				</template>
			</div>
			<div class="d-print-none" v-if="showAppBanner && ['admin', 'owner'].includes(this.$store.getters.role)">
				<div class="trial-banner" v-if="isTrial && trialExpiredBanner == false">
					<strong v-if="showTimerBanner" class="trial-banner-info"> Your trial will be expired {{daysLeftInTrial}} &nbsp;&nbsp;&nbsp;&nbsp; </strong>
					<strong v-else-if="currentDay" class="trial-banner-info"> Today is the last day of your trial plan &nbsp;&nbsp;&nbsp;&nbsp; </strong>
					<strong v-else class="trial-banner-info d-print-none"> Your trial subscription just started   &nbsp;&nbsp;&nbsp;&nbsp; </strong>
					<router-link class="btn btn-sm btn-primary" to="/dashboard/settings/subscription" custom v-slot="{ navigate }">
					<button @click="navigate" class="btn btn-sm btn-primary"><strong>Select a plan</strong></button></router-link>
				</div>
				<div class="trial-banner" v-if="trialExpiredBanner">
					<strong class="trial-banner-info"> Your trial subscription has been expired &nbsp;&nbsp;&nbsp;&nbsp; </strong>
					<router-link class="btn btn-sm btn-primary" to="/dashboard/settings/subscription" custom v-slot="{ navigate }">
					<button @click="navigate" class="btn btn-sm btn-primary"><strong>Select a plan</strong></button></router-link>
				</div>
			</div>
			<div v-if="$store.state.brand_settings['whitelabel'] == '0' && ['admin','owner','staff'].includes(this.$store.state.role)" class="footer bg-white py-4 d-flex flex-lg-column" id="kt_footer">
				<!--begin::Container-->
				<div class="container-fluid d-flex flex-column flex-md-row align-items-center justify-content-between">
					<!--begin::Copyright-->
					<div class="text-dark order-2 order-md-1">
						<span class="text-muted font-weight-bold mr-2">{{ this.year }}©</span>
						<a href="http://www.ordercircle.com" class="menu-link">OrderCircle</a>
					</div>
					<!--end::Copyright-->
				</div>
				<!--end::Container-->
			</div>
		</div>
	</div>
		<!-- AI Assistant is now integrated into sidebar -->
	</div>
	
</template>
<script>
import sidebar from './sidebar.vue';
import topbar from './topbar.vue';
import quickPanel from './quickPanel.vue';
import PlansAPIService from'@/js/api/manage-plans/plans';
import LoginAPIService from '@/js/api/auth/auth';
import { firebaseApp } from '@/js/utils/firebase';
import echo from '@/js/echo'
// ChatbotWidget removed - now integrated into sidebar

import Loader from "./Loader.vue";
export default {
	name: 'BrandLayout',
	components: {
	sidebar,
	topbar,
	quickPanel,
    Loader
  	},
	data(){
		return {
			year : new Date().getFullYear(),
			isTrial: false,
			daysLeftInTrial: '',
			subscriptionTrialDdays: import.meta.env.VITE_STRIPE_SUBSCRIPTION_TRIAL_DAYS,
			showTimerBanner: false,
			trialExpiredBanner: false,
			showAppBanner: false,
			currentDay: false,
            intercomSettings: {},
			firebaseApp: firebaseApp,
			stripeStatus: '',
			access_token : localStorage.getItem("access-token"),
		}
	},
	created(){
    /**
     *  -  Integrating Intercom
     */
		const vm = this;
		const currentUrl = window.location.href;
		if(import.meta.env.MODE === 'production' && this.$store.state.role !='' ) {
		LoginAPIService.getIntercomData().then((response) => {

			vm.intercomSettings = response?.data?.data;
			vm.intercomSettings.current_url = currentUrl;
			vm.$intercom.update(response?.data?.data);
			if (this.$intercom && typeof this.$intercom.update === "function") {
			this.$intercom.update(response?.data?.data);
			}

			// Boot Intercom with secure credentials
			if (vm.$intercom && typeof vm.$intercom.boot === "function") {
				vm.$intercom.boot({
				user_id: response?.data?.data.user_id,
				name: response?.data?.data.name,
				email: response?.data?.data.email,
				created_at: response?.data?.data.created_at,
				user_hash: response?.data?.data.user_hash,
				current_url: currentUrl
				});
			}
		}).catch((error) => {
			vm.notify("Error! ","Intercom is not working.","error");
		});
		}
		// we are using this API for impersonation from Admin to Brand having Admin token
        if(this.$route.query.token){
            this.impersonateToBrand();
        }
		if(this.$route.query.type=='xero_login'){
			this.xeroLogin();
		}
		if(this.$route.query.type=='shopify_login'){
			this.shopifyLogin();
		}
    },
	computed:{
			progressLoader(){
				return this.$store.state.loader
			},
			brandLanguage() {
				return this.$store.getters.brand?.default_brand_language;
			},
			// Email limit computed properties
			showEmailLimitAlert() {
				return this.$store.getters.isEmailLimitReached;
			},
			emailLimit() {
				return this.$store.getters.emailLimit;
			},
			emailCount() {
				return this.$store.getters.emailCount;
			}
		},
	watch: {
		brandLanguage: {
			immediate: true,
			handler(language) {
				if (language) {
					this.$i18n.locale = language;
				}
			}
		}
	},
	mounted(){
		console.log('Brand Layout Mounted');
		
		try {
		if(['admin','owner','staff'].includes(this.$store.state.role)){
			this.plansAndSubscriptions();
			this.initializeBroadcast();
        }
		if (this.$store.getters.brand && this.$store.getters.brand.brand_name) {
			document.title = this.$store.getters.brand.brand_name;
		}
		} catch (error) {
			console.error("Intercom update error:", error);
		}
        // this.$intercom.show()
    },
	methods:{
		impersonateToBrand(){
        this.$store.commit('SHOW_LOADER',true);
        LoginAPIService.impersonateToBrand({
          subdomain: this.$route.query.subdomain,
          token : this.$route.query.token,
        }).then((response) => {
          if (response.data.hasOwnProperty("success")) {
            if(response.data.success == true){
				// set the vuex from API response 
              this.$store.dispatch('getData',response.data)
              this.$store.commit('SET_PERMISSIONS', response.data.permissions);
              this.$store.commit('SET_BRAND_SETTINGS_LIST',response.data.Settings);
              this.$store.commit('SET_BRAND',response.data.brand);
              this.$store.commit('SET_BRAND_SKIN_LIST',response.data.brandSkin);
			  this.$store.commit('SET_INTEGRATIONS',response.data.integration);
				// get the url from window object
				const currentUrl = window.location.href;
						
				// Create a URL object to work with
				const url = new URL(currentUrl);
				
				// Remove the 'token' query parameter
				url.searchParams.delete('token');
				url.searchParams.delete('subdomain');
				
				// Replace the current URL in the browser's history
				window.history.replaceState({}, document.title, url.toString())
            }
            else if(response.data.success == false){
              this.$store.commit('SHOW_LOADER', false)
              this.notify("Oops...", response.data.error.error, "error");
            }         
          }
        }).catch((error) => {
          this.$store.commit('SHOW_LOADER',false);
          this.notify("Error!", "Error", "error");
        })
        },
		
		shopifyLogin(){
			this.$store.commit('SHOW_LOADER',true);
			LoginAPIService.autoLogShopify({
				subdomain: this.$route.query.subdomain,
			}).then((response) => {
				if (response.data.hasOwnProperty("success")) {
					if(response.data.success == true){
						this.$store.dispatch('getData',response.data)
						this.$store.commit('SET_PERMISSIONS', response.data.permissions);
						this.$store.commit('SET_BRAND_SETTINGS_LIST',response.data.Settings);
						this.$store.commit('SET_BRAND',response.data.brand);
						this.$store.commit('SET_BRAND_SKIN_LIST',response.data.brandSkin);
						this.$store.commit('SET_INTEGRATIONS',response.data.integration);

						// get the url from window object
						const currentUrl = window.location.href;
						
						// Create a URL object to work with
						const url = new URL(currentUrl);
						
						// Remove the 'token' query parameter
						url.searchParams.delete('path');
						url.searchParams.delete('subdomain');
						url.searchParams.delete('type');
						
						// Replace the current URL in the browser's history
						window.history.replaceState({}, document.title, url.toString())
					}
					else if(response.data.success == false){
						this.$store.commit('SHOW_LOADER', false)
						this.notify("Oops...", response.data.error.error, "error");
					}
				}
			}).catch((error) => {
				this.$store.commit('SHOW_LOADER',false);
				this.notify("Error!", "Error", "error");
			})
        },
		xeroLogin() {
			this.$store.commit('SHOW_LOADER',true);
			let subdomain = location.hostname.split('.').shift();
			LoginAPIService.autoLogXero({
				subdomain: subdomain,
			}).then((response) => {
				if (response.data.hasOwnProperty("success")) {
					if(response.data.success == true){
						this.$store.dispatch('getData',response.data)
						this.$store.commit('SET_PERMISSIONS', response.data.permissions);
						this.$store.commit('SET_BRAND_SETTINGS_LIST',response.data.Settings);
						this.$store.commit('SET_BRAND',response.data.brand);
						this.$store.commit('SET_BRAND_SKIN_LIST',response.data.brandSkin);
						this.$store.commit('SET_INTEGRATIONS',response.data.integration);

						// get the url from window object
						const currentUrl = window.location.href;
						
						// Create a URL object to work with
						const url = new URL(currentUrl);
						
						// Remove the 'token' query parameter
						url.searchParams.delete('path');
						url.searchParams.delete('subdomain');
						url.searchParams.delete('type');
						
						// Replace the current URL in the browser's history
						window.history.replaceState({}, document.title, url.toString())
					} else if(response.data.success == false){
						this.$store.commit('SHOW_LOADER', false)
						this.notify("Oops...", response.data.error.error, "error");
					}
				}
			}).catch((error) => {
				this.$store.commit('SHOW_LOADER',false);
				this.notify("Error!", "Error", "error");
			})
		},
		plansAndSubscriptions(){
			PlansAPIService.getPlansAndSubscription(this.access_token).then((response) => {
				this.stripeStatus = response.data.subscription.stripe_status;
				this.showAppBanner = response.data.subscription.stripe_price == 'free' || response.data.subscription.stripe_status == 'trialing' ? true : false
				this.isTrial = response.data.subscription.stripe_status == 'trialing' ? true: false;
				
				if(this.showAppBanner){
					// calculate number of days left in Plan Expiry
					var todayDate = moment([moment().year(), moment().month() + 1, moment().date()]);
					var trialEndDate   = moment([new Date(response.data.subscription.trial_ends_at).getUTCFullYear(), new Date(response.data.subscription.trial_ends_at).getMonth()+1, new Date(response.data.subscription.trial_ends_at).getDate()]);
					this.daysLeftInTrial = trialEndDate.from(todayDate);

					if((this.daysLeftInTrial.includes('in') || this.daysLeftInTrial.includes('a ')) && !this.daysLeftInTrial.includes('few')){
						this.daysLeftInTrial = this.daysLeftInTrial == 'a day' ? '1 day' : this.daysLeftInTrial
						this.showTimerBanner = parseInt(this.subscriptionTrialDdays) > parseInt(this.daysLeftInTrial.replace ( /[^\d.]/g, '' )) ? true : false
					}else if(this.daysLeftInTrial.includes('ago') && !this.daysLeftInTrial.includes('few')){
						this.trialExpiredBanner = true;
						this.showTimerBanner = false;
					}else if(this.daysLeftInTrial.includes('few')){
						this.trialExpiredBanner = false;
						this.showTimerBanner = false;
						this.currentDay = true;
					}
				}
			}).catch((error) => {
				this.$store.commit('SHOW_LOADER',false);
				this.notify('Error Exception!', error,'error');
			});
		},
		// Initialize Laravel Echo for real-time email limit notifications (same channel as notifications)
		initializeBroadcast() {
			try {
				const brand = this.$store.getters.brand;
				const subdomain = brand && brand['subdomain'] ? brand['subdomain'] : null;
				if (!subdomain) {
					console.warn('Subdomain not found, cannot initialize broadcast');
					return;
				}

				if (typeof echo === 'undefined') {
					console.warn('Laravel Echo not available, skipping broadcast initialization');
					return;
				}

				const channelName = `events-${subdomain}`;
				echo.channel(channelName)
					.listen('EmailLimitExceeded', (data) => {
						this.$store.commit('UPDATE_EMAIL_LIMIT_STATUS', true);
						if (data && typeof data.emailLimit === 'number' && typeof data.emailCount === 'number') {
							this.$store.commit('SET_EMAIL_LIMIT_DATA', {
								isEmailLimitReached: true,
								emailLimit: data.emailLimit,
								emailCount: data.emailCount
							});
						}
					})
					.listen('EmailCountUpdated', (data) => {
						this.$store.commit('SET_EMAIL_LIMIT_DATA', {
							isEmailLimitReached: !!data?.isEmailLimitReached,
							emailLimit: data?.emailLimit,
							emailCount: data?.emailCount
						});
					});
			} catch (error) {
				console.error('Error initializing Laravel Echo for email count:', error);
			}
		}
	}
};
</script>
<style scoped>
@import '@/js/../assets/css/brand-custom.css';


.trial-banner{
	position: fixed;
    bottom: 0;
    width: 100%;
    padding: 13px;
    text-align: center;
    background-color: #8080809e;
    color: white;
	z-index: 100;
	font-size: larger;
}
.trial-banner-info{
	margin-left: -250px;
}
@media (max-width: 990px) { 
    .trial-banner-info {
		margin-left: 0px;
    }
 }
 @media (min-width: 992px){
	.header {
	height: 65px !important;
	}
}
</style>
